<div class="tab-content-container">
	@if (!isLoadingRegisterForm) {
		<div class="form-header first" [ngClass]="{ collapsed: collapseForm.CMDB === true }">
			<span>{{ labels.lbl_geral_informacoes_gerais }}</span>
			@if (availableBaselineDates?.length > 0) {
				<div>
					<span>{{ labels.lbl_data_referencia }}&nbsp;</span>
					@if (viewType === 'read') {
						<span>
							<select (change)="setFieldsFromBaseline($event)">
								@for (date of availableBaselineDates; track date) {
									<option
										[selected]="dateService.formatDate(baselineDate.dateTime) === dateService.formatDate(date)"
										[value]="date">
										{{ dateService.formatDate(date) }}
									</option>
								}
							</select>
						</span>
					} @else {
						<span><input type="text" [value]="dateService.formatDate(todayDate.dateTime)" disabled /></span>
					}
				</div>
			}
		</div>

		@if (collapseForm.CMDB === false) {
			<cpi-generic-form-gen
				[setGenericForm]="registerForm | slice: 0 : defaultFieldsLength"
				[columns]="formColumns"
				[labels]="labels"
				[disabled]="viewType === 'read'"
				(input)="this.valueTapChanges = true"
				(valueTap)="setSelectedCi()">
			</cpi-generic-form-gen>
		}

		@if (ciFieldsLength > 0) {
			<div class="form-header" [ngClass]="{ collapsed: collapseForm.CI === true }" (click)="collapseForm.CI = !collapseForm.CI">
				<span>{{ labels.lbl_geral_informacoes_complementares }}</span>
				<span><fa-icon [icon]="collapseForm.CI === true ? icons.faAngleUp : icons.faAngleDown"></fa-icon></span>
			</div>
			<cpi-generic-form-gen
				[ngStyle]="{ display: collapseForm.CI === false ? null : 'none' }"
				[setCommunicationBusForm]="registerForm"
				[setGenericForm]="registerForm | slice: defaultFieldsLength : defaultFieldsLength + ciFieldsLength"
				[columns]="formColumns"
				[labels]="labels"
				[disabled]="viewType === 'read'"
				(input)="this.valueTapChanges = true"
				(valueTap)="setSelectedCi()">
			</cpi-generic-form-gen>
		}

		@if (customFieldsLength > 0) {
			<div
				class="form-header"
				[ngClass]="{ collapsed: collapseForm.CUSTOMFIELD === true }"
				(click)="collapseForm.CUSTOMFIELD = !collapseForm.CUSTOMFIELD">
				<span>{{ labels.lbl_geral_campos_customizados }}</span>
				<span><fa-icon [icon]="collapseForm.CUSTOMFIELD === true ? icons.faAngleUp : icons.faAngleDown"></fa-icon></span>
			</div>
			<cpi-generic-form-gen
				[ngStyle]="{ display: collapseForm.CUSTOMFIELD === false ? null : 'none' }"
				[setCommunicationBusForm]="registerForm"
				[setGenericForm]="
					registerForm | slice: defaultFieldsLength + ciFieldsLength : defaultFieldsLength + ciFieldsLength + customFieldsLength
				"
				[columns]="formColumns"
				[labels]="labels"
				[disabled]="viewType === 'read'"
				(input)="this.valueTapChanges = true"
				(valueTap)="setSelectedCi()">
			</cpi-generic-form-gen>
		}

		@if (
			permissionService.getPermission('CMDB_bind_solution_area') &&
			defaultFieldsLength + ciFieldsLength + customFieldsLength < registerForm.length
		) {
			<div
				class="form-header"
				[ngClass]="{ collapsed: collapseForm.SOLUTIONAREA === true }"
				(click)="collapseForm.SOLUTIONAREA = !collapseForm.SOLUTIONAREA">
				<span>{{ labels.lbl_asset_grupos_responsaveis }}</span>
				<span><fa-icon [icon]="collapseForm.SOLUTIONAREA === true ? icons.faAngleUp : icons.faAngleDown"></fa-icon></span>
			</div>
			<cpi-generic-form-gen
				[ngStyle]="{ display: collapseForm.SOLUTIONAREA === false ? null : 'none' }"
				[setCommunicationBusForm]="registerForm"
				[setGenericForm]="registerForm | slice: defaultFieldsLength + ciFieldsLength + customFieldsLength : registerForm.length"
				[columns]="formColumns"
				[disabled]="viewType === 'read'"
				(valueTap)="setSelectedCi()">
			</cpi-generic-form-gen>
		}

		<div class="form-container last">
			<div class="button-container">
				@if (cameFromCmdbList) {
					<a [routerLink]="'/cmdb/list'" [queryParams]="cmdbListQueryParams">
						<button>
							{{ labels.lbl_geral_voltar }}
						</button>
					</a>
				}
				@if (selectedCi.id !== '') {
					<a [routerLink]="'/request'" [queryParams]="{ view: 'selfservice', idCmdb: selectedCi.id }">
						<button>
							{{ labels.lbl_abrir_chamado }}
						</button>
					</a>
				}
				@if (selectedCi.id !== '' && showDigitalTerm()) {
					<msp-button
						[disabled]="
							(!checkPermissionByType() && !permissionService.getPermission('cmdb_digital_term_logistic_operator')) ||
							disableDigitalTermEditing()
						"
						(click)="openDigitalTermModal(selectedCi.id)">
						{{ labels.lbl_termo_digital }}
					</msp-button>
				}
			</div>
			<div class="button-container">
				@if (viewType === 'edit' && selectedCi.id === '') {
					<span>
						<input
							type="number"
							[min]="1"
							[max]="20"
							[value]="registerQuantity === 1 ? null : registerQuantity"
							[placeholder]="'QTD'"
							(input)="setRegisterQuantity($event)" />
					</span>
				}

				@if (clonedId !== '') {
					<button class="button" [disabled]="isUpdatingCi || isLoadingDynamicSubSelect.length > 0" (click)="cancelClone()">
						{{ labels.lbl_cancelar_clonagem }}
					</button>
				}

				@if (viewType === 'edit' && selectedCi.id === '') {
					<msp-button
						[disabled]="isUpdatingCi || isLoadingDynamicSubSelect.length > 0"
						[loading]="isUpdatingCi"
						(click)="registerCi(true)">
						{{ labels.lbl_geral_registrar }} {{ labels.lbl_geral_e }} {{ labels.lbl_geral_clonar }}
					</msp-button>
				}

				@if (viewType === 'edit' && selectedCi.id === '' && registerQuantity <= 1) {
					<msp-button
						[disabled]="isUpdatingCi || isLoadingDynamicSubSelect.length > 0"
						[loading]="isUpdatingCi"
						(click)="registerCi(false)">
						{{ labels.lbl_geral_registrar }}
					</msp-button>
				}

				@if (viewType === 'edit' && selectedCi.id === '' && registerQuantity > 1) {
					<msp-button
						[disabled]="isUpdatingCi || isLoadingDynamicSubSelect.length > 0"
						[loading]="isUpdatingCi"
						(click)="confirmMassRegisterModal.openModal()">
						{{ labels.lbl_geral_registrar }}
					</msp-button>
				}

				@if (viewType === 'edit' && selectedCi.id !== '') {
					<msp-button [disabled]="isUpdatingCi || isLoadingDynamicSubSelect.length > 0" (click)="viewTypeChange.emit('read')">
						{{ labels.lbl_cancelar_edicao }}
					</msp-button>
					<msp-button [disabled]="isUpdatingCi || isLoadingDynamicSubSelect.length > 0" (click)="cloneCi()">
						{{ labels.lbl_geral_clonar }}
					</msp-button>
					<msp-button
						[disabled]="isUpdatingCi || isLoadingDynamicSubSelect.length > 0"
						[loading]="isUpdatingCi"
						(click)="updateCi()">
						{{ labels.lbl_geral_atualizar }}
					</msp-button>
				}

				@if (viewType === 'read' && selectedCi.id !== '' && !lockViewType) {
					<msp-button
						[disabled]="!checkPermissionByType() && !permissionService.hasPermission('cmdb_digital_term_logistic_operator')"
						(click)="viewTypeChange.emit('edit')">
						{{ labels.lbl_geral_editar }}
					</msp-button>
				}
			</div>
		</div>
	} @else {
		<div class="loading-container">
			<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
		</div>
	}
</div>

<cpi-modal
	#confirmMassRegisterModal
	[title]="labels.lbl_confirmar_criacao_de_quantidade_ativos.replace('§_quantity_§', registerQuantity.toString())"
	[showFooter]="true">
	<ng-container footer>
		<div class="button-container">
			<button (click)="confirmMassRegisterModal.closeModal()">{{ labels.lbl_geral_cancelar }}</button>
			<button (click)="massRegisterCi(); confirmMassRegisterModal.closeModal()">
				{{ labels.lbl_geral_registrar }}
			</button>
		</div>
	</ng-container>
</cpi-modal>

<cpi-modal
	[title]="labels.lbl_termo_digital"
	[showFooter]="isLoadingDigitalTerm === false"
	(onModalClose)="isEditingTerm = false; setFieldsFromMemory()"
	#digitalTermModal>
	<ng-container body>
		@if (!isLoadingDigitalTerm) {
			<div class="cmdb-digital-term-modal-body">
				<cpi-generic-form-gen
					[setGenericForm]="cmdbDigitalTermForm"
					[columns]="1"
					[labels]="labels"
					[boldLabel]="false"
					[disabled]="true">
				</cpi-generic-form-gen>

				@if (!isLoadingUserCopy) {
					@if (baselineToDigitalTermPayload.status === 'Em Estoque' || baselineToDigitalTermPayload.status === 'Stock') {
						<div class="dotted-input-container mt-1">
							<span>{{ labels.lbl_geral_substituto_responsavel }}</span>
							<cpi-input-with-autocomplete
								[availableOptions]="allowedUserCopyIAC"
								[placeholder]="
									labels.lbl_geral_substituto_responsavel +
									' (' +
									labels.lbl_iac_min_char_search.replace('$__$', '3') +
									')'
								"
								[minInputLength]="3"
								(onValueChange)="cmdbDigitalTermPayload.user_substitute = $event"
								[disabled]="!isEditingTerm">
							</cpi-input-with-autocomplete>
						</div>
					}
				}

				<div class="dotted-input-container">
					<span>{{ labels.lbl_checklist }}?*</span>
					<select [(ngModel)]="cmdbDigitalTermPayload.checklist" [disabled]="!isEditingTerm">
						<option [value]="-1" disabled>{{ labels.lbl_geral_selecione }}</option>
						<option value="1">{{ labels.lbl_geral_sim }}</option>
						<option value="0">{{ labels.lbl_geral_nao }}</option>
					</select>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_devolucao_troca_equipamento }}?*</span>
					<select [(ngModel)]="cmdbDigitalTermPayload.return_or_exchange_equipment" [disabled]="!isEditingTerm">
						<option [value]="-1" disabled>{{ labels.lbl_geral_selecione }}</option>
						<option value="1">{{ labels.lbl_geral_sim }}</option>
						<option value="0">{{ labels.lbl_geral_nao }}</option>
					</select>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_usuario_desligado }}?*</span>
					<select [(ngModel)]="cmdbDigitalTermPayload.user_disconnected" [disabled]="!isEditingTerm">
						<option [value]="-1" disabled>{{ labels.lbl_geral_selecione }}</option>
						<option value="1">{{ labels.lbl_geral_sim }}</option>
						<option value="0">{{ labels.lbl_geral_nao }}</option>
					</select>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_usuario_terceiro }}?*</span>
					<select [(ngModel)]="cmdbDigitalTermPayload.third_party_user" [disabled]="!isEditingTerm">
						<option [value]="-1" disabled>{{ labels.lbl_geral_selecione }}</option>
						<option value="1">{{ labels.lbl_geral_sim }}</option>
						<option value="0">{{ labels.lbl_geral_nao }}</option>
					</select>
				</div>

				<div>
					@if (!isEditingTerm) {
						@if (
							cmdbDigitalTermPayload.id === '' &&
							(cmdbDigitalTermPayload.signature === null || cmdbDigitalTermPayload.signature === '')
						) {
							<span class="tip"> *{{ labels.lbl_solicitacao_assinatura_nao_enviada }} </span>
						} @else if (cmdbDigitalTermPayload.id !== '' && cmdbDigitalTermPayload.signature === '') {
							<span class="tip"> *{{ labels.lbl_solicitacao_assinatura_enviada }} </span>
						} @else if (cmdbDigitalTermPayload.signature && cmdbDigitalTermPayload.signature !== '') {
							<span class="tip"> *{{ labels.lbl_termo_assinado }} </span>
						}
					}
				</div>
			</div>
		} @else {
			<div class="loading-container">
				<cpi-svg-gears></cpi-svg-gears>
				<div>{{ labels.lbl_edocs_carregando }}!</div>
			</div>
		}
	</ng-container>

	<ng-container footer>
		<button (click)="toggleEditMode()">
			@if (isEditingTerm) {
				<span>{{ labels.lbl_geral_cancelar }}</span>
			} @else {
				<span>{{ labels.lbl_geral_editar }}</span>
			}
		</button>

		@if (isEditingTerm) {
			<button
				id="digitalTermConfirmButton"
				[ngClass]="{ disabled: isUpdatingDigitalTerm, b2: isUserNotified }"
				(click)="saveCmdbDigitalTerm()">
				{{ isUserNotified ? labels.lbl_geral_confirmar : labels.lbl_geral_salvar }}
				@if (isUpdatingDigitalTerm) {
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'"></cpi-dot-bounce-loading-effect>
				}
			</button>
		}
	</ng-container>
</cpi-modal>

<cpi-modal #infoUserModal [showFooter]="false">
	<ng-container body>
		@if (modalIdEnduser) {
			<app-user-modal [idEnduser]="modalIdEnduser"> </app-user-modal>
		}
	</ng-container>
</cpi-modal>
